module.exports = __webpack_public_path__ + "static/media/error-404.4a34c7ba.png";